import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    enableLcdSubscriptions,
    enableLcdSubscriptionsProgress,
    stopSubscriptionEnable,
} from 'src/openapi/admin/apis/BulkLcdSubscriptionEnableApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    LCD_SUBSCRIPTION_MODAL_WIDTH,
    LCS_SUBSCRIPTION_TITLES,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
} from '../constants';
import {
    UpdateLcdCreditAnalysisSubscriptionModal,
} from '../update-lcd-credit-analysis-subscription.modal';

import {
    setBackgroundTask,
    setShown,
    setUuid,
    subscribeToLcdCreditAnalysisTaskSelector,
    subscribeToLcdCreditAnalysisUuidSelector,
} from './subscribe-to-lcd-credit-analysis.slice';

import type {BulkLcdEnabledRequest} from 'src/openapi/admin/models/BulkLcdEnabledRequest';

type Props = {
    shown: boolean,
    usersIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const SubscribeToLcdCreditAnalysisTool = ({shown, usersIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<BulkLcdEnabledRequest>
            shown={shown}
            onClose={onClose}
            width={LCD_SUBSCRIPTION_MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={LCS_SUBSCRIPTION_TITLES.SUBSCRIBE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={subscribeToLcdCreditAnalysisTaskSelector}
            uuidSelector={subscribeToLcdCreditAnalysisUuidSelector}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(bulkLcdEnabledRequest, options) => (
                apiDispatch(enableLcdSubscriptions({...options, bulkLcdEnabledRequest}))
            )}
            getProgress={id => apiDispatch(enableLcdSubscriptionsProgress({id}))}
            stopAction={id => apiDispatch(stopSubscriptionEnable({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UpdateLcdCreditAnalysisSubscriptionModal {...{
                    usersIds,
                    subscribe: true,
                    onCloseModal, processAction,
                }}
                />
            )}
        </BulkActionTool>
    );
};
